import { render, staticRenderFns } from "./CampusSceneryManage.vue?vue&type=template&id=9cf2049a&scoped=true"
import script from "./CampusSceneryManage.vue?vue&type=script&lang=js"
export * from "./CampusSceneryManage.vue?vue&type=script&lang=js"
import style0 from "./CampusSceneryManage.vue?vue&type=style&index=0&id=9cf2049a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf2049a",
  null
  
)

export default component.exports